// Shared cast hierarchy styling utilities for OneLiner and Schedule
// Usage: import { getHierarchyStyle, hasHierarchy } from '../utils/castStyles';

import { alpha } from '@mui/material/styles';

export const hasHierarchy = (h) => Number.isFinite(h) && h >= 1;

// Returns { bg, border } based on hierarchy using theme palette
export const getHierarchyStyle = (hierarchy, theme) => {
  // Match Cast.js palette order and defaults
  // Cast.js getHierarchyColor(): [error, info, success, warning, secondary|primary, primary, grey[500]]
  const fallbackGrey = theme.palette.grey ? (theme.palette.grey[400] || '#bdbdbd') : '#bdbdbd';
  if (!hasHierarchy(hierarchy)) {
    const base = fallbackGrey;
    const isDark = theme.palette.mode === 'dark';
    return { bg: alpha(base, isDark ? 0.12 : 0.08), border: base };
  }
  const cycle = [
    theme.palette.error.main,                                 // 1 -> red
    theme.palette.info.main,                                  // 2 -> blue
    theme.palette.success.main,                               // 3 -> green
    theme.palette.warning.main,                               // 4 -> yellow
    (theme.palette.secondary?.main || theme.palette.primary.main), // 5
    theme.palette.primary.main,                               // 6
    (theme.palette.grey?.[500] || fallbackGrey)               // 7
  ];
  const idx = (Math.max(1, hierarchy) - 1) % cycle.length;
  const base = cycle[idx] || fallbackGrey;
  const isDark = theme.palette.mode === 'dark';
  return {
    bg: alpha(base, isDark ? 0.12 : 0.08),
    border: base,
  };
};
